// extracted by mini-css-extract-plugin
export var codeBox = "index-module--codeBox--1dc31";
export var codeContainer = "index-module--codeContainer--ca3ab";
export var darkBackground = "index-module--darkBackground--a6b41";
export var demo = "index-module--demo--82b14";
export var exampleContainer = "index-module--exampleContainer--65b44";
export var exampleTitle = "index-module--exampleTitle--9efcc";
export var lighterBackground = "index-module--lighterBackground--5484d";
export var section = "index-module--section--5f2f7";
export var sparkleTarget = "index-module--sparkleTarget--3ff77";
export var sparkleTextTarget = "index-module--sparkleTextTarget--2e3f9";
export var titleLink = "index-module--titleLink--6fc2a";